import React from 'react';
import { isDataExist, validateEditorData } from './editor/defaultOptions.js';
import Editor from './editor/editor.jsx';

const CustomFieldEditor = ({ field, isEmptyReturn }) => {
  const editorData = validateEditorData(field.data);

  const isEditorDataExist =
    editorData && !!isDataExist(validateEditorData(field.data));

  if (editorData && isEditorDataExist) {
    return (
      <Editor
        key={`${field.key}-${editorData.time || Date.now()}`}
        options={{
          holder: `change-strategy-custom-field-editor-${field.key}`,
          readOnly: true,
          minHeight: 0,
        }}
        data={editorData}
        customClass="m-0"
      />
    );
  }

  return !isEmptyReturn ? '—' : '';
};

export default CustomFieldEditor;
